import type { AccountMappingPaymentLocation } from "api/models";

export type AccountMappingRow = {
  id?: number;
  payment_location: string;
  external_account_number: string;
  shipper_name?: string;
  location_name?: string;
};

export type AccountMappingFormValues = {
  mappings: AccountMappingRow[];
};

export type PaymentLocationOptionsSource = {
  paymentLocations: AccountMappingPaymentLocation[];
  isLoading: boolean;
  isFetching: boolean;
  isFetchingNextPage: boolean;
  hasNextPage: boolean | undefined;
  fetchNextPage: () => void;
};

export const EMPTY_ACCOUNT_MAPPING_ROW: AccountMappingRow = {
  payment_location: "",
  external_account_number: "",
  shipper_name: "",
  location_name: "",
};
